import sortBy from 'lodash/sortBy';
import { useMemo } from 'react';
import { CountryState } from '../../../common/components/SearchHeader/constants';
import { FilterChoice } from '../../../common/components/SearchHeader/types/FilterChoice';
import { useHannibalQuery } from '../../../common/schema/hannibal/HannibalContext';
import { SuburbListDocument } from '../../../common/schema/hannibal/types.generated';
import { parseToEnum } from '../../../common/util/parseToEnum';
import { SuburbLinks } from './SuburbLinks';

interface Props {
  metro: string;
  filters: FilterChoice;
  isSidebar?: boolean;
}

export const MetroSuburbLinks = ({ metro, filters, isSidebar = false }: Props) => {
  const { data } = useHannibalQuery(SuburbListDocument, { variables: { metro } });

  const suburbs = data?.searchSuburbsByName.suburbs;

  const sorted = useMemo(() => sortBy(suburbs, it => it.name), [suburbs]).map(suburb => ({
    suburb: {
      name: suburb.name,
      postcode: suburb.postcode,
      state: parseToEnum(suburb.state, CountryState) ?? undefined,
    },
  }));

  return <SuburbLinks filters={filters} locations={sorted ?? []} isSidebar={isSidebar} />;
};
